import type { FC } from 'react';
import { Form, Input, Select, DatePicker } from 'antd';
import type { FormInstance } from 'antd';
import type { Dayjs } from 'dayjs';

const CHANNEL_OPTIONS = [
  { value: 'linkedin', label: 'LinkedIn' },
  { value: 'email', label: 'Email' },
  { value: 'blog', label: 'Blog' },
  { value: 'multi', label: 'Multi-canal' },
];

const STATUS_OPTIONS = [
  { value: 'draft', label: 'Brouillon' },
  { value: 'active', label: 'Active' },
  { value: 'paused', label: 'En pause' },
  { value: 'completed', label: 'Terminée' },
];

const PERSONA_OPTIONS = [
  { value: 'cto', label: 'CTO' },
  { value: 'product_owner', label: 'Product Owner' },
  { value: 'ceo_startup', label: 'CEO Startup' },
  { value: 'qa_lead', label: 'QA Lead' },
];

export interface InfoFormValues {
  name: string;
  channel: string;
  startDate?: Dayjs;
  endDate?: Dayjs;
  targetPersona?: string;
  status: string;
  description?: string;
}

interface CampaignInfoTabProps {
  form: FormInstance<InfoFormValues>;
}

const CampaignInfoTab: FC<CampaignInfoTabProps> = ({ form }) => (
  <Form form={form} layout="vertical" className="mt-2">
    <Form.Item name="name" label="Nom" rules={[{ required: true, message: 'Nom requis' }]}>
      <Input placeholder="Nom de la campagne" />
    </Form.Item>
    <div className="grid grid-cols-2 gap-4">
      <Form.Item name="channel" label="Canal" rules={[{ required: true }]} initialValue="multi">
        <Select options={CHANNEL_OPTIONS} />
      </Form.Item>
      <Form.Item name="targetPersona" label="Persona cible">
        <Select options={PERSONA_OPTIONS} allowClear placeholder="Sélectionner" />
      </Form.Item>
    </div>
    <div className="grid grid-cols-2 gap-4">
      <Form.Item name="startDate" label="Date début">
        <DatePicker className="w-full" format="DD/MM/YYYY" />
      </Form.Item>
      <Form.Item name="endDate" label="Date fin">
        <DatePicker className="w-full" format="DD/MM/YYYY" />
      </Form.Item>
    </div>
    <Form.Item name="status" label="Statut" rules={[{ required: true }]} initialValue="draft">
      <Select options={STATUS_OPTIONS} />
    </Form.Item>
    <Form.Item name="description" label="Description">
      <Input.TextArea rows={3} placeholder="Notes de suivi de la campagne..." />
    </Form.Item>
  </Form>
);

export default CampaignInfoTab;
